import script from "./detailsinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsinfo.vue?vue&type=script&setup=true&lang=js"

import "./detailsinfo.vue?vue&type=style&index=0&id=6307a8ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6307a8ba"]])

export default __exports__